import { render, staticRenderFns } from "./RevaluarOT.vue?vue&type=template&id=5c892bf8&lang=pug"
import script from "./RevaluarOT.vue?vue&type=script&lang=js"
export * from "./RevaluarOT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports